import WaitingPeriodServices from './WaitingPeriodServices';
import WaitingPeriodServicesMock from './WaitingPeriodServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? WaitingPeriodServicesMock : WaitingPeriodServices;
